import { render, staticRenderFns } from "./ProductStorePricingSection.vue?vue&type=template&id=72cffe13&scoped=true"
import script from "./ProductStorePricingSection.vue?vue&type=script&lang=js"
export * from "./ProductStorePricingSection.vue?vue&type=script&lang=js"
import style0 from "./ProductStorePricingSection.vue?vue&type=style&index=0&id=72cffe13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cffe13",
  null
  
)

export default component.exports